import Reveal from "./Reveal";

const pillars = [
  {
    icon: "ri-user-heart-line",
    title: "Atendimento individualizado",
    copy: "Cada pessoa é única. O cuidado respeita a história, o ritmo e a necessidade de cada um.",
  },
  {
    icon: "ri-flask-line",
    title: "Ciência e atualização",
    copy: "Prática baseada em conhecimento científico e constante atualização profissional.",
  },
  {
    icon: "ri-flashlight-line",
    title: "Tecnologia como aliada",
    copy: "Recursos terapêuticos, como a Laserterapia, integrados de forma responsável ao cuidado.",
  },
  {
    icon: "ri-chat-3-line",
    title: "Acolhimento e escuta",
    copy: "Comunicação clara, humana e empática em cada etapa do acompanhamento.",
  },
  {
    icon: "ri-home-heart-line",
    title: "Home Care",
    copy: "Atendimento no conforto do lar, com comodidade e segurança.",
  },
];

export default function Differentials() {
  return (
    <section className="bg-background-100 py-16 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary-600">
              Diferenciais
            </p>
            <h2 className="mt-4 font-heading text-4xl font-semibold leading-[1.1] tracking-tight text-foreground-950 md:text-5xl">
              Um olhar especializado para cada necessidade.
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-x-10 gap-y-12 md:grid-cols-2 lg:grid-cols-3">
          {pillars.map((pillar, i) => (
            <Reveal key={pillar.title} delay={i * 60}>
              <div className="group border-t border-primary-600/20 pt-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-colors duration-300 group-hover:bg-primary-600 group-hover:text-background-50">
                  <i className={`${pillar.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-5 font-heading text-xl font-semibold text-foreground-950">
                  {pillar.title}
                </h3>
                <p className="mt-3 text-base leading-relaxed text-foreground-600">
                  {pillar.copy}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}